export const MessageType = {
	none: 0,
	order_changes: 1,
	load_doc_status_changes: 2,
}